import * as Types from 'src/actions/project/comments/create-child-comment/Types';
import {
  CreateProjectChildCommentAction
} from 'src/actions/project/comments/create-child-comment/CreateProjectChildComment.actions';

export interface CreateProjectChildCommentState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateProjectChildCommentState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateProjectChildCommentReducer(state: CreateProjectChildCommentState = initialState,
                                                 action: CreateProjectChildCommentAction):
  CreateProjectChildCommentState {
  switch (action.type) {
    case Types.CREATE_PROJECT_CHILD_COMMENT_ATTEMPT:
      return {...state, loading: true, error: false};
    case Types.CREATE_PROJECT_CHILD_COMMENT_SUCCESS:
      return {...state, loading: false, error: false};
    case Types.CREATE_PROJECT_CHILD_COMMENT_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/comments/CreateProjectChildCommentsReducer.tsx